import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "../../../../assets/scss/result.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import x_mark from "../../../../assets/images/courses/group.svg";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import PaginatedItems from "../../../../components/tables/paginationResult";
import PaginatedItemsWritten from "../../../../components/tables/paginationResultWritten";
import Repository from "../../../../configs/axios/repository";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PaginatedItemsFlashcard from "../../../../components/tables/paginationResultFlashcard";

const AnswerQuestions = (props) => {
    const location = useLocation();
    let type = location.state?.type;
    const queryParameters = new URLSearchParams(window.location.search);
    const id = queryParameters.get("id");
    const [loadingData, setLoadingData] = useState(false);
    const [answers, setAnswers] = useState(null);
    const [isData, setIsData] = useState(false);

    const history = useHistory();

    const findById = async () => {
        const result = await Repository.postRequest(
            `api/resultTestFlashcard/findResultTestFlashcardByTestId`,
            {
                id: id,
                type: type,
            }
        );
        if (result.data.success == true) {
            if (result.data.data == null) {
                history.push({
                    pathname: `/quizLog`,
                });
            } else {
                setIsData(true);
                setAnswers(JSON.parse(result.data.data.answers));
            }
        }
        setLoadingData(true);
    };

    useEffect(() => {
        findById();
    }, []);

    return loadingData ? (
        <div className="testBodyDiv homeSection">
            <div className=" resultCard">
                <div>
                    <div className="resultHeaderResult">
                        <h1>Results Answers</h1>
                        <div className="nextBtnDiv">
                            <button
                                className="mt-1"
                                onClick={() => {
                                    history.push({
                                        pathname: `/quizLog`,
                                    });
                                }}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                </div>
                <div className="pgItems">
                    {type == "written" ? (
                        <PaginatedItemsWritten
                            itemsPerPage={4}
                            items={answers}
                            isCreate={false}
                        />
                    ) : type == "flashcard" ? (
                        <PaginatedItemsFlashcard
                            itemsPerPage={4}
                            items={answers}
                            isCreate={false}
                        />
                    ) : (
                        <PaginatedItems
                            itemsPerPage={4}
                            items={answers}
                            role={"student"}
                            isCreate={false}
                        />
                    )}
                </div>
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default AnswerQuestions;
